import { Component, Input } from '@angular/core';

import { ReportDataType, ReportVisualization } from '../../../services/report-query';

@Component({
  selector: 'app-report-value',
  standalone: false,
  templateUrl: './report-value.html',
  styleUrl: './report-value.scss',
})
export class ReportValue {
  @Input() value: unknown;
  @Input() dataType: ReportDataType = 'number';
  @Input() visualization: ReportVisualization = 'number';
  @Input() currencyCode = 'USD';
  @Input() locale = 'en-US';

  get numericValue(): number {
    const value = typeof this.value === 'number' ? this.value : Number(this.value ?? 0);
    return Number.isFinite(value) ? value : 0;
  }

  get boundedPercentage(): number {
    return Math.min(100, Math.max(0, this.numericValue));
  }

  get formattedValue(): string {
    if (this.dataType === 'currency' || this.visualization === 'currency') {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currencyCode,
        maximumFractionDigits: 2,
      }).format(this.numericValue);
    }

    if (this.dataType === 'percentage' || this.visualization.startsWith('percentage')) {
      return `${new Intl.NumberFormat(this.locale, { maximumFractionDigits: 1 }).format(this.numericValue)}%`;
    }

    return new Intl.NumberFormat(this.locale, { maximumFractionDigits: 2 }).format(
      this.numericValue,
    );
  }
}
